'use client';

import { resolveObjectArray } from '@macaron-a2ui/core/v0_8';
import { childIds } from './helpers';
import type { MacaronRenderContext, RecordAny } from '@macaron-a2ui/core/v0_8';

export function MacaronBottomBar({ config, ctx }: { config: RecordAny; ctx: MacaronRenderContext }) {
  const child = typeof config.child === 'string' ? config.child : '';
  const ids = childIds(config.children);
  const items = resolveObjectArray(config.items, ctx.data);
  const childNodes = child ? [child] : ids;
  const shouldStretchButtonGroup = childNodes.length > 0 && childNodes.length <= 3 && childNodes.every((id) => ctx.getComponentType?.(id) === 'Button');

  if (childNodes.length > 0) {
    return (
      <div className="flex w-full items-end justify-center gap-2">
        {childNodes.map((id) => (
          <div key={id} className={shouldStretchButtonGroup ? 'min-w-0 flex-1' : undefined}>
            {ctx.renderChild(id)}
          </div>
        ))}
      </div>
    );
  }

  return (
    <div className="flex w-full items-end justify-center gap-2">
      {items.map((it, i) => {
        const title = typeof it.title === 'string' ? it.title : `Item ${i + 1}`;
        const action = typeof it.action === 'string' ? it.action : 'bottom_bar_click';
        return (
          <button key={`${title}-${i}`} type="button" className="rounded-md px-2 py-1 text-xs text-[#344054]" onClick={() => ctx.onAction?.(action, ctx.componentId, { index: i, title })}>
            {title}
          </button>
        );
      })}
    </div>
  );
}
